import React from "react";

// reactstrap components
import {
    Container,
} from "reactstrap";

function HomePageVideo({ style, videoRef }) {
    //get current window height

    return (
        <>
            {/* Video */}
            <div className="header-4" style={style}>
                <div className="header-wrapper" >
                    <div className="page-header header-video" style={{ display: "flex", alignContent: "center", justifyContent: "center", backgroundColor: "#000000" }}>
                        {/* We show the video image placeholder instead of the video for small devices */}
                        <video
                            id="video-source"
                            loop="loop"
                            muted="muted"
                            preload="auto"
                            volume="0"
                            ref={videoRef}
                            style={{ minHeight: "100vh" }}
                        >
                            <source
                                src={require("assets/video/event.mp4")}
                                type="video/mp4"
                            ></source>
                            Video not supported
                        </video>
                        <div className="filter" />
                        <div className="content-center">
                            <Container className="upper-container text-center">
                                <div className="video-text">
                                    {/* <h2>Our</h2> */}
                                    <h1 className="title-uppercase title-no-upper-margin" style={{ fontSize: "6vh", fontWeight: 500 }}>
                                        Smart Event & Production
                                    </h1>
                                </div>
                                <br />
                            </Container>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default HomePageVideo;
